import { render, staticRenderFns } from "./ColorModuleWelcomeModal.vue?vue&type=template&id=95dd122a&scoped=true"
import script from "./ColorModuleWelcomeModal.vue?vue&type=script&lang=ts"
export * from "./ColorModuleWelcomeModal.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleWelcomeModal.vue?vue&type=style&index=0&id=95dd122a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dd122a",
  null
  
)

export default component.exports